/**
 * 블로그 페이지
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toArray } from "@/lib/array";
import { Article } from "@shared/schema";
import { useQuery } from "@tanstack/react-query";
import { formatDistanceToNow } from "date-fns";
import { ko } from "date-fns/locale";
import { Link } from "wouter";

export default function Blog() {
  const { data: rawArticles, isLoading } = useQuery({
    queryKey: ["/api/articles"],
  });

  const articles = toArray<Article>(rawArticles)
    .filter((a) => a.status === "published")
    .slice(0, 12);

  return (
    <>
      <Seo
        title="블로그 — OZK News"
        description="OZK News의 최신 소식과 업데이트를 확인하세요."
        path="/blog"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">블로그</h1>
            <p className="text-lg text-muted-foreground">
              OZK News의 최신 소식과 업데이트
            </p>
          </div>

          {isLoading ? (
            <div className="text-center py-12">
              <p className="text-muted-foreground">로딩 중...</p>
            </div>
          ) : articles.length === 0 ? (
            <Card>
              <CardContent className="py-12 text-center">
                <p className="text-muted-foreground">
                  아직 게시된 글이 없습니다.
                </p>
              </CardContent>
            </Card>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link key={article.id} href={`/article/${article.id}`}>
                  <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer">
                    <CardHeader>
                      <CardTitle className="line-clamp-2">
                        {article.title}
                      </CardTitle>
                      <p className="text-sm text-muted-foreground">
                        {formatDistanceToNow(
                          new Date(article.publishedAt || article.createdAt),
                          {
                            addSuffix: true,
                            locale: ko,
                          }
                        )}
                      </p>
                    </CardHeader>
                    <CardContent>
                      {article.summary && (
                        <p className="text-sm text-muted-foreground line-clamp-3">
                          {article.summary}
                        </p>
                      )}
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
